import { CloseIconButton } from '@library/components/buttons';
import { memo } from 'react';

/** A generic drawer header for the Drawer component */
export const DrawerHeader = memo(
  ({
    onClickClose,
    subtitle,
    children
  }: {
    onClickClose: () => void | undefined;
    subtitle: string | undefined;
    children: React.ReactNode;
  }) => {
    return (
      <div className="border-soFresh-140 flex h-16 items-center border-b px-6 py-2">
        <div className="flex h-full flex-col justify-evenly">
          {subtitle && (
            <p className="text-soClean-180 text-sm leading-none">{subtitle}</p>
          )}
          <p className="text-soClean-100 text-lg leading-none">{children}</p>
        </div>
        {onClickClose && (
          <CloseIconButton handleOnClick={onClickClose} className="ml-auto" />
        )}
      </div>
    );
  }
);
